// Prefilter utilities for equipment management

export const getOperatorLabel = (operator: string): string => {
  // Unified: always return symbolic label for display everywhere
  const symbolic: Record<string, string> = {
    "=": "=",
    "!=": "!=",
    ">": ">",
    "<": "<",
    ">=": ">=",
    "<=": "<=",
    ILIKE: "ILIKE",
  };
  return symbolic[operator] || operator;
};

export const getOperatorOptions = (attrType: string) => {
  if (attrType === "string" || attrType === "list" || attrType === "comments") {
    return [
      { value: "ILIKE", label: "ILIKE" },
      { value: "=", label: "=" },
      { value: "!=", label: "!=" },
    ];
  }
  return [
    { value: "=", label: "=" },
    { value: "!=", label: "!=" },
    { value: ">", label: ">" },
    { value: "<", label: "<" },
    { value: ">=", label: ">=" },
    { value: "<=", label: "<=" },
  ];
};
